/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_External_Code_EditInputs */

const en_case_field_external_code_edit = /** @type {(inputs: Case_Field_External_Code_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit external identifier`)
};

const pt_br2_case_field_external_code_edit = /** @type {(inputs: Case_Field_External_Code_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar identificador externo`)
};

/**
* | output |
* | --- |
* | "Edit external identifier" |
*
* @param {Case_Field_External_Code_EditInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_external_code_edit = /** @type {((inputs?: Case_Field_External_Code_EditInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_External_Code_EditInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_external_code_edit(inputs)
	return pt_br2_case_field_external_code_edit(inputs)
});